import { render, staticRenderFns } from "./FakeInput.vue?vue&type=template&id=604e2ed8&scoped=true"
import script from "./FakeInput.vue?vue&type=script&lang=js"
export * from "./FakeInput.vue?vue&type=script&lang=js"
import style0 from "./FakeInput.vue?vue&type=style&index=0&id=604e2ed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604e2ed8",
  null
  
)

export default component.exports